import Theme from '../../../theme';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Message = styled.p`
  color: ${Theme.colors.black.hexCode};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
